import { render, staticRenderFns } from "./CourseInfoCoursePreference.vue?vue&type=template&id=08a386f0&"
import script from "./CourseInfoCoursePreference.vue?vue&type=script&lang=js&"
export * from "./CourseInfoCoursePreference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports